import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import _pick from 'lodash/pick';
import _omit from 'lodash/omit';
import { AffordabilityCalculator as AffordabilityCalculator$1, AffordabilityCalculatorShape } from '@zillow/zrs-cms';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

var _zconfigs = {
  prod: {
    serverURLs: {
      MAX: 'https://mortgageapi.zillow.com'
    },
    partnerId: 'RD-WXDQSGN'
  },
  default: {
    serverURLs: {
      MAX: 'https://mortgageapi.qa.zillow.net'
    },
    partnerId: 'RD-GKZRBBL'
  }
};
var BlockAffordabilityCalculator = function BlockAffordabilityCalculator(_ref) {
  var attrs = _ref.attrs,
    index = _ref.index;
  useEffect(function () {
    var _zconfig = _zconfigs[process.env.NEXT_PUBLIC_ENV] || _zconfigs.default;
    if (window._zconfig) {
      if (!window._zconfig.partnerId) {
        window._zconfig.partnerId = _zconfig.partnerId;
      }
      if (!window._zconfig.serverURLs) {
        window._zconfig.serverURLs = {};
      }
      if (!window._zconfig.serverURLs.MAX) {
        window._zconfig.serverURLs.MAX = _zconfig.serverURLs.MAX;
      }
    } else {
      window._zconfig = _zconfig;
    }
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "zmm-api-config",
    dangerouslySetInnerHTML: {
      __html: '<!-- {"serverURLs":{}} -->'
    },
    style: {
      display: 'none'
    }
  }), /*#__PURE__*/React.createElement(AffordabilityCalculator$1, _extends({
    defaultValues: _pick(attrs, Object.keys(AffordabilityCalculatorShape))
  }, _omit(attrs, Object.keys(AffordabilityCalculatorShape)), {
    key: index
  })));
};
BlockAffordabilityCalculator.propTypes = process.env.NODE_ENV !== "production" ? {
  index: PropTypes.number,
  attrs: PropTypes.shape(AffordabilityCalculatorShape)
} : {};
var AffordabilityCalculator = BlockAffordabilityCalculator;

export { AffordabilityCalculator as default };
